import gql from 'graphql-tag/lib';

const getCompaniesEmailRecordsQuery = gql`
  query ($zoneId: ObjectId!, $companyIds: [ObjectId!]) {
    emailRecords: companiesEmailRecords(zoneId: $zoneId, companyIds: $companyIds) {
      _id
      messageType
      title
      message
      to
      from
      attachment
      sent
      status
      user {
        firstname
        lastname
      }
      bookletId
      booklet {
        _id
        title
      }
      company{
        name
      }
    }
  }
`;

const getReviewEmailRecordsQuery = gql`
  query ($zoneId: ObjectId!, $companyId: ObjectId!, $bookletId: ObjectId!) {
    emailRecords: couponsReviewEmailRecords(zoneId: $zoneId, companyId: $companyId, bookletId: $bookletId) {
      _id
      messageType
      title
      message
      to
      from
      attachment
      sent
      status
      user {
        firstname
        lastname
      }
      bookletId
      booklet {
        title
      }
      company {
        name
      }
      review{
        coupons {
          terms
          discount
          smallTitle
          description
        }
      }
    }
  }
`;

const getReviewEmailRecordQueryZone = gql`
  query ($reviewId: ObjectId!, $zoneId: ObjectId!) {
    emailRecord: couponsReviewEmailRecordZone(reviewId: $reviewId, zoneId: $zoneId) {
      status
    }
  }
`;



export {
  getCompaniesEmailRecordsQuery,
  getReviewEmailRecordsQuery,
  getReviewEmailRecordQueryZone
}

